<template>
    <div class="responsiveTabs">
        <slot></slot>
    </div>
</template>

<script>
	export default {
		name: "ResponsiveTabs"
	}
</script>



// WEBPACK FOOTER //
// src/components/common/tabs/TabsWrapper.vue